import { IconClock } from "@tabler/icons-react";
import { Text } from "@mantine/core";

export const timeToComplete = (time: string) => (
  <div className="time-container">
    <IconClock color="gray" />
    <Text c="dimmed">{time} min</Text>
  </div>
);

// Define the interface for type safety
interface DemoLink {
  title: string;
  link: string;
  image: string;
  type: string;
  time: string;
}

// Import the JSON data
import demoLinksData from "./demoLinks.json";

// Cast the imported data to the DemoLink[] type
const demoLinks: DemoLink[] = demoLinksData as DemoLink[];

export const filterDemoLinks = (selectedType: string): DemoLink[] => {
  if (selectedType === "all-resources") {
    // If "All resources" is selected, return all demo links
    return demoLinks;
  }

  // Filter demoLinks based on the selected type
  return demoLinks.filter((demo) => demo.type === selectedType);
};

export const demoOptions = [
  { value: "all-resources", label: "All resources" },
  { value: "smartwiz", label: "Smartwiz" },
  { value: "taxwise", label: "TaxWise" },
];
